var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTranslate24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9H21C21.4125 9 21.75 9.3375 21.75 9.75V18.75C21.75 19.575 21.075 20.25 20.25 20.25H9.38139C9.11838 20.25 8.93708 19.9863 9.03126 19.7407L14.9687 4.25928C15.0629 4.01371 14.8816 3.75 14.6186 3.75H3.75C2.925 3.75 2.25 4.425 2.25 5.25V14.25C2.25 14.6625 2.5875 15 3 15H6",
    stroke: "current",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.801 17.7251C12.6508 18.1112 12.842 18.5458 13.2281 18.696C13.6141 18.8462 14.0488 18.655 14.199 18.269L12.801 17.7251ZM18.801 18.269C18.9512 18.655 19.3859 18.8462 19.7719 18.696C20.158 18.5458 20.3492 18.1112 20.199 17.7251L18.801 18.269ZM17.011 11.5995L16.312 11.8714L17.011 11.5995ZM14.199 18.269L16.688 11.8714L15.2901 11.3275L12.801 17.7251L14.199 18.269ZM20.199 17.7251L17.7099 11.3275L16.312 11.8714L18.801 18.269L20.199 17.7251ZM16.5 10.5C15.9646 10.5 15.4842 10.8286 15.2901 11.3275L16.688 11.8714C16.6578 11.9489 16.5832 12 16.5 12V10.5ZM16.5 12C16.4168 12 16.3422 11.9489 16.312 11.8714L17.7099 11.3275C17.5158 10.8286 17.0354 10.5 16.5 10.5V12Z",
    className: "filled",
    fill: "current",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 15.75H14.25",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinejoin: "bevel"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 15.75C8.66421 15.75 9 15.4142 9 15C9 14.5858 8.66421 14.25 8.25 14.25C7.83579 14.25 7.5 14.5858 7.5 15C7.5 15.4142 7.83579 15.75 8.25 15.75Z",
    className: "filled",
    fill: "current",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 7.5H9.75L5.25 12",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5V6",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 10.125L9.75 12",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslate24);
export default __webpack_public_path__ + "static/media/Translate-24.b9286ab5.svg";
export { ForwardRef as ReactComponent };